import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_94ned2lnmo: FaireBrandEntity = {
  token: "b_94ned2lnmo",
  type: "brand",
  name: "Mo&Co Home",
  avatarUrl:
    "https://cdn.faire.com/fastly/bf4736178cbaced813c928fb7b0798a2ea44efa6a3e1edc84f65c4f08c2c0ccf.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/71d27d0e806e415dbbd00a5bc788b90da00d75a109a2b6ee8872efed3e362519.png",
  logoUrl:
    "https://cdn.faire.com/fastly/bf4736178cbaced813c928fb7b0798a2ea44efa6a3e1edc84f65c4f08c2c0ccf.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/71d27d0e806e415dbbd00a5bc788b90da00d75a109a2b6ee8872efed3e362519.png",
  location: "Atlanta, GA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 119,
  isTopShop: true,
  isInsider: true,
  description:
    "Mo&Co Home is a USA-based candle company, inspired by the ethereal beauty of Mother Nature. Each candle is thoughtfully handmade from sustainably sourced beeswax and cotton from the USA, eco-consciously colored, and free from artificial fragrance to create the cleanest burning candle experience possible. Harmoniously released with the turn of each season, our candles bring the magical essence of nature to your homes and lives. \n\n",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:54:57.203Z",
    importedBy: "entity-db-cli",
  },
};
